export const ACCEPT = 'image/*, video/*';

export const EMPTY_PREVIEW = {
  created: 0,
  version: '',
  filename: '',
  type: '',
  src: '',
};
